import Date from '../../../client/date.js'
import Form from '../../../client/form.js'
import Image from '../../../client/image.js'
import Network from '../../../client/network.js'
import Ui from '../../../client/ui.js'

export default class _common
{
	static _open = {}

	static init()
	{
		$(function()
		{
			Date.init()
			Image.init()
			Network.init()
			Form.limit_number_input()

			Ui.scroll()
			Ui.modal()

			_common.menu_toggle()
		})
	}

	static menu_toggle()
	{
		if('ontouchstart' in document.documentElement)
		{
			$('.__nav_arrow').each((index, element) =>
			{
				const section = $(element).data('name')
				if(!section) return

				element.addEventListener('click', () =>
				{
					_common._open[section] = !_common._open[section]
					_common.menu(section, _common._open[section])
				})
			})

			$('#__nav ul a').each((index, element) =>
			{
				element.addEventListener('click', () =>
				{
					$('.__nav_close').hide()
					$('.__nav_open').fadeIn().css('display', 'inline-block')

					$('#__nav').fadeOut()
				})
			})
		}
		else
		{
			$('.__nav_title, #__nav ul').each((index, element) =>
			{
				const section = $(element).data('name')
				if(!section) return

				element.addEventListener('mouseenter', () => _common.menu(section, true))
				element.addEventListener('mouseleave', () => _common.menu(section, false))
			})
		}

		$('.__nav_open').on('click', () =>
		{
			$('.__nav_open').hide()
			$('.__nav_close').fadeIn().css('display', 'inline-block')

			$('#__nav').fadeIn()
		})

		$('.__nav_close').on('click', () =>
		{
			$('.__nav_close').hide()
			$('.__nav_open').fadeIn().css('display', 'inline-block')

			$('#__nav').fadeOut()
		})
	}

	static login(form)
	{
		try
		{
			App.common.Network.form_post(form, (success) =>
			{
				const last = /\blast=(.+?)(;|$)/.exec(document.cookie)
				const redirect = last ? decodeURIComponent(last[1]) : '/my/'

				if(success) setTimeout(() => location.href = redirect, 2000)
			})

			return false
		}
		catch(exception)
		{
			console.error(exception.message)
			return false
		}
	}

	static _fade_duration_second = 0.5

	static _timeout = {}

	static _timeout_wait = {}

	static _previous_section = null

	static menu(section, enter)
	{
		if(this._timeout[section] !== null) clearTimeout(this._timeout[section])
		if(this._timeout_wait[section] !== null) clearTimeout(this._timeout_wait[section])

		const area = $(`#__nav_${section}`)

		if(enter)
		{
			area.removeClass('__nav-hide')
			area.addClass('__nav-show')

			area.removeClass('hidden')
		}
		else
		{
			this._timeout_wait[section] = setTimeout(() =>
			{
				area.removeClass('__nav-show')
				area.addClass('__nav-hide')

				this._timeout[section] = setTimeout(() =>
				{
					area.addClass('hidden')

					this._timeout[section] = null
				}, this._fade_duration_second * 1000)
			}, 100)
		}

		this._previous_section = section
	}

	static cookie(key, value)
	{
		if(value === undefined)
		{
			// https://stackoverflow.com/a/25490531
			const regex = new RegExp(`(?:^|;)\\s*${key}\\s*=\\s*([^;]*)`)
			const match = regex.exec(document.cookie)

			return match ? decodeURIComponent(match[1]) : null
		}
		else
		{
			const age = value === null ? 0 : 86400 * 30
			document.cookie = `${key}=${encodeURIComponent(value)}; path=/; max-age=${age}`
		}
	}
}
